module.exports = __webpack_public_path__ + "img/mark_star_5_icon.d5d745f4.png";